import { render, staticRenderFns } from "./VirtualProviderDashboard.vue?vue&type=template&id=04b401d5&"
import script from "./VirtualProviderDashboard.vue?vue&type=script&lang=js&"
export * from "./VirtualProviderDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports